import { createFileRoute } from '@tanstack/react-router';
import { useSessions } from '@/hooks/use-sessions';
import { SessionList } from '@/components/sessions/session-list';
import { EmptyState } from '@/components/common/empty-state';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

export const Route = createFileRoute('/_authenticated/sites/$siteId/sessions/')({
  component: SessionsPage,
});

function SessionsPage() {
  const { siteId } = Route.useParams();
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useSessions(siteId);

  const all = data?.pages.flatMap((p) => p.sessions) ?? [];
  const total = data?.pages[0]?.total ?? 0;

  return (
    <div className="mx-auto max-w-7xl px-6 py-8 animate-fade-up">
      <header className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold tracking-tight">Sessions</h1>
        <p className="text-sm text-text-muted">{total} total sessions</p>
      </header>

      {isLoading ? (
        <Skeleton className="h-96 w-full" />
      ) : all.length === 0 ? (
        <EmptyState
          title="No sessions yet"
          description="Install the tracker on your site to start capturing sessions."
        />
      ) : (
        <>
          <SessionList siteId={siteId} sessions={all} />
          {hasNextPage && (
            <div className="mt-4 text-center">
              <Button variant="outline" onClick={() => fetchNextPage()} disabled={isFetchingNextPage}>
                {isFetchingNextPage ? 'Loading…' : 'Load more'}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
